import { render, staticRenderFns } from "./TemplateLayer.vue?vue&type=template&id=7c8bb172&scoped=true"
import script from "./TemplateLayer.vue?vue&type=script&lang=js"
export * from "./TemplateLayer.vue?vue&type=script&lang=js"
import style0 from "./TemplateLayer.vue?vue&type=style&index=0&id=7c8bb172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8bb172",
  null
  
)

export default component.exports